<template>
  <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form
      :label-position="left"
      :inline="true"
      size="mini"
      label-width="80px"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item label="菜品名称">
          <el-input v-model="formInline.goodsName"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="value7"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
        <el-button size="mini" type="primary" @click="exportart">导出</el-button>
      </el-row>
      <el-row>
        <el-col :span="16" style="font-size:14px;color:#606266">销售数量:{{totalSaleCount}}</el-col>
      </el-row>
    </el-form>
    <el-table
      size="mini"
      ref="multipleTable"
      :data="tableData3"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" type="index" width="55px"></el-table-column>
      <el-table-column prop="gdName" label="菜品名称"></el-table-column>
      <el-table-column prop="saleCount" label="销售数量"></el-table-column>
      <el-table-column prop="unitId" label="计量单位"></el-table-column>
      <el-table-column prop="recDate" label="销售时间"></el-table-column>
    </el-table>
    <br />
    <div class="block">
      <el-pagination
        class="right"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-size="20"
        layout="total, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <export-file ref="exportFile" :URL="URL"></export-file>
  </div>
</template>

<script>
import Eve from "../../../components/common/emit.js";
import { baseurl } from "../../../base.js";
export default {
  mounted() {
    Eve.$on("goodCountList", () => {
      this.load();
    });
    this.load();
  },
  data() {
    return {
      value7: [this.getNowFormatDate(), this.getNowFormatDate()],
      options: {
        1: "桌位管理",
        2: "销售分类",
        3: "菜品管理",
        4: "订单管理",
        5: "设置打印"
      },
      fullscreenLoading: false,
      page: {
        total: 0
      },
      URL: `${baseurl}/w/statistic/export`,
      left: "left",
      tableData3: [],
      formInline: {
        startTime: "",
        goodsName: "",
        endTime: "",
        page: 1,
        size: 20
      },
      totalSaleCount:""
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.formInline.page = index;
      this.load();
    },
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    load() {
      if (!this.value7) {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      } else {
        this.formInline.startTime = this.value7[0];
        this.formInline.endTime = this.value7[1];
      }
      this.fullscreenLoading = true;
      this.$http
        .post(
          `/w/statistic/list?pageNumber=${this.formInline.page}&pageSize=${this.formInline.size}`,
          this.formInline
        )
        .then(data => {
          this.fullscreenLoading = false;
          this.tableData3 = data.data;
          this.page.total = data.pageable.totalElements;
          this.totalSaleCount=data.extendData.totalSaleCount;
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });
    },
    exportart() {
      if (!this.value7) {
        this.formInline.startTime = '';
        this.formInline.endTime = '';
      } else {
        this.formInline.startTime = this.value7[0];
        this.formInline.endTime = this.value7[1];
      }
      let form = {...this.formInline};
        delete form.page;
        delete form.size
      let data = {
        ...form,
        platCode: '900001',
        tokenId:localStorage.getItem("tokenId"),
        merId:localStorage.getItem("merId")
      };
      this.$refs["exportFile"].export(data);
    },
    search() {
      this.formInline.page = 1;
      this.load();
    }
  }
};
</script>

<style scoped>
.right {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/view/page/sellCount/sellCount.vue